import apiClient from 'api/services/apiClient';
import { MESSAGE_COMMON } from 'constants/string/messages';
import { isApiResponseError, validateMessageResponse } from 'utils/helper';

export const videoSamples = async (data) => {
  await apiClient.setHeaderFormData();
  const response = await apiClient.request('POST', '/admin/file-samples', data);
  if (!isApiResponseError(response)) {
    apiClient.resetHeader();
    return {
      ...response.data,
      ...validateMessageResponse(response.data.message, 'string', MESSAGE_COMMON.SUCCESS),
    };
  } else {
    apiClient.resetHeader();
    throw {
      ...validateMessageResponse(response.jp_message, 'string', MESSAGE_COMMON.FAILURE),
      field_names: response?.error?.field_names || [],
    };
  }
};

export const videoSamplesList = async (query) => {
  const response = await apiClient.request('GET', `/admin/file-samples${query}`);
  if (!isApiResponseError(response)) {
    return response?.data;
  } else {
    throw validateMessageResponse(response.jp_message, 'string', MESSAGE_COMMON.FAILURE);
  }
};

export const videoSamplesDeleteByIds = async (query) => {
  const response = await apiClient.request('DELETE', `/admin/file-samples${query}`);
  if (!isApiResponseError(response)) {
    return true;
  } else {
    throw validateMessageResponse(response.jp_message, 'string', MESSAGE_COMMON.FAILURE);
  }
};

export const videoSamplesGetByCategoryId = async (categoryId) => {
  const response = await apiClient.request('GET', `/admin/file-samples/${categoryId}`);
  if (!isApiResponseError(response)) {
    return response?.data;
  } else {
    throw validateMessageResponse(response.jp_message, 'string', MESSAGE_COMMON.FAILURE);
  }
};

export const videoSamplesUpdate = async (data, categoryId) => {
  await apiClient.setHeaderFormData();
  const response = await apiClient.request('PUT', `/admin/file-samples/${categoryId}`, data);
  if (!isApiResponseError(response)) {
    apiClient.resetHeader();
    return {
      ...response.data,
      ...validateMessageResponse(response.data.message, 'string', MESSAGE_COMMON.SUCCESS),
    };
  } else {
    apiClient.resetHeader();
    throw {
      ...validateMessageResponse(response.jp_message, 'string', MESSAGE_COMMON.FAILURE),
      field_names: response?.error?.field_names || [],
    };
  }
};
